import { useState } from 'react'
import { FilterState } from './types/filters'

export const useForm = () => {
  const [formData, setFormData] = useState<Partial<FilterState>>({})
  const [showModal, setShowModal] = useState(false)

  const handleAddData = () => {
    setFormData({})
    setShowModal(true)
  }

  const handleDisplayData = (data: Partial<FilterState>) => {
    setFormData(data)
    setShowModal(true)
  }

  const handleUpdateData = (data: any) => {
    setFormData(data)
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
    setFormData({})
  }

  return {
    formData,
    showModal,
    handleCloseModal,
    setFormData,
    handleDisplayData,
    handleAddData,
    handleUpdateData,
  } as const
}
